import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";
import { motion } from "framer-motion";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/554e6605-a254-4d96-97b8-16b0adab1b40" +
  "?include=field_imagen1.field_media_image,field_imagen2.field_media_image,field_imagen3.field_media_image," +
  "field_imagen5.field_media_image,field_imagen6.field_media_image," +
  "field_imagen8.field_media_image,field_imagen9.field_media_image" +
  "&fields[node--template_home]=title,field_texto_portada,field_imagen1,field_imagen2,field_imagen3,field_imagen5,field_imagen6,field_imagen8,field_imagen9,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function GovTechSpeakers() {
  const DataDisplay = ({ data }) => (
    <div>
      <div className="flex flex-wrap justify-center gap-6 w-full max-w-6xl mx-auto pb-24">
        {data.bloque8 && (
          <motion.div
            className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 0.5 }}
          >
            <img
              src={data.imagen8}
              alt="utpl"
              className="w-full h-[200px] object-cover rounded-2xl shadow-lg"
            />

            <div
              className="[&_h2]:font-bold "
              dangerouslySetInnerHTML={{
                __html: data.bloque8,
              }}
            />
          </motion.div>
        )}

        {data.bloque9 && (
          <motion.div
            className="w-full md:w-[calc(50%-12px)] p-6 bg-white rounded-xl border border-slate-200/80 shadow-sm"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 1 }}
          >
            <img
              src={data.imagen9}
              alt="utpl"
              className="w-full h-[200px] object-cover rounded-2xl shadow-lg"
            />
            <div
              className="[&_h2]:font-bold "
              dangerouslySetInnerHTML={{
                __html: data.bloque9,
              }}
            />
          </motion.div>
        )}
      </div>

      <section className="py-20 px-6">
        <div
          className="max-w-6xl mx-auto text-center mb-6   [&_h2]:font-bold "
          dangerouslySetInnerHTML={{
            __html: data.texto_portada,
          }}
        />

        <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-10">
          <div className="w-full sm:w-[320px] flex flex-col items-center  ">
            <img
              src={data.imagen1}
              alt="Speaker 1"
              className="w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />
            <div
              className="mt-6 link-with-arrow-1"
              dangerouslySetInnerHTML={{
                __html: data.bloque1,
              }}
            />
          </div>

          <div className="w-full sm:w-[320px] flex flex-col items-center ">
            <img
              src={data.imagen2}
              alt="Speaker 2"
              className="w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />

            <div
              className="mt-6 link-with-arrow-1"
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          </div>

          <div className="w-full sm:w-[320px] flex flex-col items-center  ">
            <img
              src={data.imagen3}
              alt="Speaker 3"
              className="w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />

            <div
              className="mt-6 link-with-arrow-1"
              dangerouslySetInnerHTML={{
                __html: data.bloque3,
              }}
            />
          </div>
        </div>
      </section>

      <section className="py-20 px-6">
        <div
          className="max-w-6xl mx-auto text-center mb-6   [&_h2]:font-bold"
          dangerouslySetInnerHTML={{
            __html: data.bloque4,
          }}
        />

        <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-10">
          <div className="w-full sm:w-[320px] flex flex-col items-center  ">
            <img
              src={data.imagen5}
              alt="Speaker 1"
              className="w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />
            <div
              className="mt-6 link-with-arrow-1"
              dangerouslySetInnerHTML={{
                __html: data.bloque5,
              }}
            />
          </div>

          <div className="w-full sm:w-[320px] flex flex-col items-center ">
            <img
              src={data.imagen6}
              alt="Speaker 2"
              className="w-full aspect-[4/5] object-cover rounded-2xl shadow-lg"
            />

            <div
              className="mt-6 link-with-arrow-1"
              dangerouslySetInnerHTML={{
                __html: data.bloque6,
              }}
            />
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome>
  );
}

export default GovTechSpeakers;
